import { Layout } from '@roc/client-portal-shared/components';
import { Greeting } from '@roc/feature-app-core';
import { PortalBannerMessages } from 'libs/client-portal-shared/src/app/modules/dashboard/components/portalBannerMessages';
import { useExternalAgentRoutes } from '../hooks/useExternalAgentRoutes';

export const ExternalAgentHome = () => {
  const {
    externalAgentLoanRoutesConfig,
  } = useExternalAgentRoutes();

  return (
    <Layout>
      <PortalBannerMessages />
      <Greeting
        text={''}
        buttonLabel="GO TO LOANS"
        buttonLink={externalAgentLoanRoutesConfig.loansHome.url}
      />
    </Layout>
  );
}